import type { FaireProductEntity } from "../../entity_types/product";

export const p_6vptrh5vqp: FaireProductEntity = {
  token: "p_6vptrh5vqp",
  type: "product",
  name: "Soft Serve Love You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/56f0d089dff7d105bc3d8872b9d38f1952e2bcb1468fb04c24c4ecae02efa2ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dcab778a76414e77453678af299348bb77bf9385f8fdf4bf9f4f2ed4959fb279.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:34.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
